import React, { useEffect, useState } from 'react';
import $ from 'jquery';
import 'datatables.net';
const DataTableLayout = ({ tableId, ajaxUrl, columns, onPayAgain, traceBtnClick, ajaxMethod = 'GET', headers = {}, dependency = null }) => {
  const [loadingTableId, setLoadingTableId] = useState(null);

  useEffect(() => {
    let dataTableInstance;
    let isMounted = true;
    let filterTimeout;

    const loadScriptAndInitialize = async () => {
      try {
        const module = await import('../../../datatable.js'); // Dynamically import
        if (!isMounted) return;

        const initFunc = module.initializeDataTable || window.initializeDataTable;

        if (typeof initFunc === 'function') {
          dataTableInstance = initFunc({
            selector: `#${tableId}`,
            columns,
            ajaxUrl,
            ajaxMethod,
            headers,
          });
        }
        
        // ---- handle pay again / onPayAgain funciton target to marketplace-pay-btn class

        $(document).on('click', `#${tableId} .marketplace-pay-btn`, function (e) {
          const marketplaceAccountId = $(this).data("record-id");

          const $btn = $(this);

          //  inline-flex + align-middle lagao
          $btn.html(`
    <span class="d-inline-flex align-items-center">
      <span class="spinner-border spinner-border-sm me-1 align-middle" role="status"></span>
      <span class="align-middle">Processing...</span>
    </span>
  `);

          $btn.prop("disabled", true);

          if (onPayAgain) {
            setLoadingTableId(marketplaceAccountId)
            onPayAgain(e, marketplaceAccountId);
          }
        });

        const buildColumnFilter = () => {
          if (!isMounted) return;
          const filterContainer = document.querySelector(
            `#${tableId}_wrapper .custom_data_filter_col .col-6.text-end`
          );

          if (filterContainer) {
            if (document.getElementById(`column-dropdown-${tableId}`)) return;

            const filterWrap = document.createElement("div");
            filterWrap.id = `column-dropdown-${tableId}`;
            // Prepend right before the export buttons
            const dtButtons = filterContainer.querySelector('.dt-buttons');
            if (dtButtons) {
              dtButtons.parentNode.insertBefore(filterWrap, dtButtons);
            } else {
              filterContainer.appendChild(filterWrap);
            }

            filterWrap.innerHTML = `
              <button id="col-btn-${tableId}" class="btn btn-secondary buttons-csv buttons-html5">
                <i class="bi bi-funnel"></i>
              </button>
              <div class="col-dropdown-box" id="col-dropdown-box-${tableId}" style="display:none; width: 280px;">
                <div class="dropdown-select-all">
                  <input type="checkbox" id="select-all-cols-${tableId}" checked />
                  <label style="font-weight:500;">Select All</label>
                </div>
                <div style="max-height:220px; overflow-y:auto; overflow-x:hidden;">
                  ${columns
                .map((col, idx) => ({ ...col, originalIdx: idx }))
                .filter(col => !["Marketplace", "Product", "Marketplace Account", "Total Sale Amount", "Total Net Sale Amount"].includes(col.title || col.data))
                .map((col) => {
                  const label = col.title || col.data;
                  return `
                    <div class="truncate-2-lines">
                      <input type="checkbox" checked data-idx="${col.originalIdx}" />
                      <label>${label}</label>
                    </div>
                  `}).join("")}
                </div>
                <div style="display:flex; justify-content:space-between; margin-top:10px;">
                  <button id="close-col-${tableId}" class="btn btn-light w-sm-auto px-3 py-0 rounded-3 border shadow-sm">Close</button>
                  <button id="update-col-${tableId}" class="btn plan-detail-card-btn rounded-3">Update</button>
                </div>
              </div>
            `;

            const btn = document.getElementById(`col-btn-${tableId}`);
            const box = document.getElementById(`col-dropdown-box-${tableId}`);

            btn.onclick = () => {
              box.style.display = box.style.display === "none" ? "block" : "none";
            };

            const closeBtn = document.getElementById(`close-col-${tableId}`);
            closeBtn.onclick = () => {
              // Revert checkboxes to actual visible state before closing
              const dt = $(`#${tableId}`).DataTable();
              columnCheckboxes.forEach(cb => {
                const idx = cb.getAttribute("data-idx");
                cb.checked = dt.column(idx).visible();
              });
              const allChecked = Array.from(columnCheckboxes).every(c => c.checked);
              selectAllCb.checked = allChecked;
              box.style.display = "none";
            };

            const selectAllCb = document.getElementById(`select-all-cols-${tableId}`);
            const columnCheckboxes = box.querySelectorAll("input[data-idx]");

            selectAllCb.onchange = (e) => {
              const isChecked = e.target.checked;
              columnCheckboxes.forEach(cb => {
                cb.checked = isChecked;
              });
            };

            columnCheckboxes.forEach(cb => {
              cb.onchange = (e) => {
                const allChecked = Array.from(columnCheckboxes).every(c => c.checked);
                selectAllCb.checked = allChecked;
              };
            });

            const updateBtn = document.getElementById(`update-col-${tableId}`);
            const dt = $(`#${tableId}`).DataTable();
            updateBtn.onclick = () => {
              columnCheckboxes.forEach(cb => {
                const idx = cb.getAttribute("data-idx");
                dt.column(idx).visible(cb.checked);
              });
              box.style.display = "none";
            };
          }
        };

        filterTimeout = setTimeout(buildColumnFilter, 500);

      } catch (error) {
        if (isMounted) {
          console.error('Failed to load or initialize datatable.js:', error);
        }
      }
    };

    loadScriptAndInitialize();

    return () => {
      isMounted = false;
      if (filterTimeout) clearTimeout(filterTimeout);

      // Clean up event listener
      $(document).off('click', `#${tableId} .marketplace-pay-btn`);

      // Remove manual DOM additions
      const filterWrap = document.getElementById(`column-dropdown-${tableId}`);
      if (filterWrap) {
        filterWrap.remove();
      }

      // Clean up on unmount
      if ($.fn.DataTable.isDataTable(`#${tableId}`)) {
        $(`#${tableId}`).DataTable().destroy();
      }
    };
  }, [tableId, ajaxUrl, columns, dependency]);


  useEffect(() => {
    if (!traceBtnClick?.isLoading && traceBtnClick?.btnClickPackageId === null && loadingTableId) {
      // sirf usi button ko reset karo jiska id match kare
      $(`#${tableId} .marketplace-pay-btn[data-record-id="${loadingTableId}"]`)
        .html("Pay Now")
        .prop("disabled", false);
      setLoadingTableId(null)
    }

    return () => {
      // Optional: extra cleanup if needed for this effect
    };
  }, [traceBtnClick, tableId, loadingTableId]);



  const tableElement = (
    <table id={tableId} className="display">
      <thead>
        <tr>
          {columns.map((col, index) => (
            <th key={index}>{col.title || col.data}</th>
          ))}
        </tr>
      </thead>
    </table>
  );

  return (
    <React.Fragment key={dependency || 'default'}>
      {tableId === 'orders_table' ? (
        <div id={`${tableId}-container`}>
          {tableElement}
        </div>
      ) : (
        tableElement
      )}
    </React.Fragment>
  );
};

export default DataTableLayout;
